import { useRef } from 'react'
import { cleanProtocolHtml } from '../utils/cleanProtocolHtml'
import { apiAuth } from '../services/apiAuth'

type Service = {
  id: number
  protocol?: string
}

export function useServiceProtocol() {
  const cache = useRef<Map<number, string>>(new Map())

  async function getProtocol(serviceId: number) {
    if (cache.current.has(serviceId)) {
      return cache.current.get(serviceId)!
    }

    const response = await apiAuth.get(`clinics/services/${serviceId}/`)
    const service = response.data as Service

    const cleaned = cleanProtocolHtml(service.protocol || '')

    cache.current.set(serviceId, cleaned)

    return cleaned
  }

  return { getProtocol }
}
